import React from "react";
import { DocsViewer } from "../components/DocsViewer";
import "../studio.css";

export default function Docs() {
  return (
    <div className="page-docs" data-testid="docs-page">
      <div className="slim-head"><h1>Documentation</h1></div>
      <DocsViewer />
    </div>
  );
}
